import { Component, Signal } from '@angular/core';
import { WebsiteStateService } from '../../state-management/services/website-state.service';
import { BusinessConfiguration } from '../../state-management/model/interfaces/state.model';
import { Navbar } from '../../components/shared/navbar/navbar.component';

@Component({
    selector: 'app-impressum',
    standalone: true,
    imports: [Navbar],
    templateUrl: './impressum.component.html',
    styleUrl: './impressum.component.scss'
})
export class ImpressumComponent {

  public metaData: Signal<BusinessConfiguration> = this.websiteState.configuration;

  constructor(
    private websiteState: WebsiteStateService
  ) { }

  ngOnInit() {
   }

}
